import React from 'react';
import ReactDOM from 'react-dom/client';
import '@/index.css';
import App from '@/App';

// -----------------------------------------------------------------------------
// Patch v17.7 — Impersonation-token URL param handshake.
//
// When a god admin clicks "View as User" in the Admin User Directory, the
// backend mints an impersonation JWT and the frontend opens a NEW browser
// tab at:  /app?impersonation_token=<JWT>
//
// This block runs BEFORE React mounts. If the URL carries the token, we:
//   1. Copy the token into ``sessionStorage`` (tab-scoped, does NOT
//      disturb the god admin's ``localStorage`` session in other tabs).
//   2. Strip the query string from the URL so the token never leaks into
//      the browser history / referer header / analytics.
// The api client (see /src/api/client.js) picks the sessionStorage token
// up automatically for every request originating from this tab.
// -----------------------------------------------------------------------------
try {
  const usp = new URLSearchParams(window.location.search);
  const impToken = usp.get('impersonation_token');
  if (impToken) {
    sessionStorage.setItem('impersonation_token', impToken);
    usp.delete('impersonation_token');
    const cleanQuery = usp.toString();
    const newUrl = window.location.pathname + (cleanQuery ? `?${cleanQuery}` : '');
    window.history.replaceState({}, '', newUrl);
  }
} catch {
  // If sessionStorage is unavailable (very old browsers, private mode
  // edge-cases) we silently degrade — impersonation just won't work in
  // that tab, and the god admin will see a normal login screen.
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
